/* Presentation only: menu, product rails and local brand filters. */
(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  let opener = null;
  let activeMenu = null;

  document.addEventListener('keydown', event => {
    if (event.key === ' ' && event.target instanceof Element && event.target.matches('a[data-arpro-shop-menu-open]')) {
      event.preventDefault();
      event.target.click();
    }
  });

  function releaseMenu(menu) {
    document.body.classList.remove('arpro-shop-menu-is-open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (activeMenu === menu) activeMenu = null;
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-arpro-shop-menu-open]');
    if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      const menu = document.getElementById(trigger.getAttribute('aria-controls'));
      if (menu && typeof menu.showModal === 'function') {
        event.preventDefault();
        opener = trigger;
        activeMenu = menu;
        menu.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('arpro-shop-menu-is-open');
      }
      return;
    }
    const menu = event.target.closest('[data-arpro-shop-menu]');
    if (menu && menu.open) {
      const bounds = menu.getBoundingClientRect();
      const outside = event.target === menu && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
      if (outside || event.target.closest('[data-arpro-shop-menu-close]') || event.target.closest('a')) {
        // Close synchronously before another dialog's delegated handler runs.
        menu.close();
        releaseMenu(menu);
      }
    }
  }, true);

  document.addEventListener('close', event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-arpro-shop-menu]')) return;
    releaseMenu(event.target);
    // Native dialog restores its opener. Do not steal focus from a new dialog.
    if (!document.querySelector('dialog[open]') && opener && opener.isConnected && opener.getClientRects().length && (document.activeElement === document.body || event.target.contains(document.activeElement))) opener.focus();
  }, true);

  document.addEventListener('shopify:section:unload', event => {
    if (activeMenu && event.target.contains(activeMenu)) {
      activeMenu.close();
      releaseMenu(activeMenu);
    }
  });

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-arpro-browse-brand]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const catalogue = document.querySelector('[data-arpro-catalogue]');
    const form = catalogue && catalogue.querySelector('[data-arpro-catalogue-filters]');
    const brand = form && form.querySelector('[data-arpro-catalogue-brand]');
    if (!brand) return;
    const option = Array.from(brand.options).find(item => item.value && normalize(item.value) === normalize(link.dataset.arproBrowseBrand));
    if (!option) return; // The real Shopify search link remains the fallback.
    event.preventDefault();
    form.reset();
    brand.value = option.value;
    brand.dispatchEvent(new Event('change', { bubbles: true }));
    catalogue.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    const result = catalogue.querySelector('[data-arpro-catalogue-result]');
    if (result) {
      result.setAttribute('tabindex', '-1');
      result.focus({ preventScroll: true });
    } else {
      brand.focus({ preventScroll: true });
    }
  });
})();


/* Browsing controls. No cart, account, pricing or network mutations. */
(() => {
  'use strict';

  function arproUi(key, fallback, values) {
    var translations = window.arproI18n;
    var template = translations && Object.prototype.hasOwnProperty.call(translations, key) && typeof translations[key] === "string" && translations[key]
      ? translations[key] : fallback;
    return String(template).replace(/\{([A-Za-z][A-Za-z0-9_]*)\}/g, function (match, name) {
      return values && Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match;
    });
  }
  const rails = new WeakMap();
  const catalogues = new WeakMap();
  const zoomOpeners = new WeakMap();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(root) {
    const viewport = root.querySelector('[data-arpro-rail-viewport]');
    const controls = root.querySelector('[data-arpro-rail-controls]');
    const existing = rails.get(root);
    if (existing && existing.viewport === viewport && existing.controls === controls) {
      existing.update();
      return;
    }
    if (existing) existing.destroy();
    if (!viewport || !controls) return;
    const previous = controls.querySelector('[data-arpro-rail-prev]');
    const next = controls.querySelector('[data-arpro-rail-next]');
    const counter = controls.querySelector('[data-arpro-rail-counter]');
    if (!previous || !next || !counter) return;
    const controller = new AbortController();
    const signal = controller.signal;
    let destination = null;
    let settleTimer;
    const maximum = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const update = () => {
      const width = viewport.clientWidth;
      if (!width) return;
      const limit = maximum();
      const pages = Math.max(1, Math.ceil((viewport.scrollWidth - 1) / width));
      if (destination !== null) destination = Math.min(limit, destination);
      const position = destination === null ? viewport.scrollLeft : destination;
      const page = limit <= 1 ? 1 : position >= limit - 2 ? pages : Math.min(pages, Math.round(Math.max(0, position) / width) + 1);
      controls.hidden = limit <= 1;
      previous.disabled = position <= 1;
      next.disabled = position >= limit - 1;
      const text = arproUi("js_rail_page", "Page {page} sur {pages}", { page: page, pages: pages });
      if (counter.textContent !== text) counter.textContent = text;
    };
    const settle = () => {
      clearTimeout(settleTimer);
      destination = null;
      update();
    };
    const move = direction => {
      const origin = destination === null ? viewport.scrollLeft : destination;
      destination = direction === 'start' ? 0 : direction === 'end' ? maximum() : Math.min(maximum(), Math.max(0, origin + direction * viewport.clientWidth));
      viewport.scrollTo({left: destination, behavior: reducedMotion() ? 'auto' : 'smooth'});
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 700);
      update();
    };
    previous.addEventListener('click', () => move(-1), {signal});
    next.addEventListener('click', () => move(1), {signal});
    viewport.addEventListener('scroll', update, {passive: true, signal});
    viewport.addEventListener('scrollend', settle, {signal});
    ['pointerdown', 'wheel', 'touchstart'].forEach(type => viewport.addEventListener(type, settle, {passive: true, signal}));
    viewport.addEventListener('keydown', event => {
      if (event.target !== viewport) return;
      const directions = {ArrowLeft: -1, ArrowRight: 1, Home: 'start', End: 'end'};
      if (Object.prototype.hasOwnProperty.call(directions, event.key)) {
        event.preventDefault();
        move(directions[event.key]);
      }
    }, {signal});
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
    if (observer) observer.observe(viewport);
    const childrenObserver = new MutationObserver(update);
    childrenObserver.observe(viewport, {childList: true});
    window.addEventListener('resize', update, {passive: true, signal});
    rails.set(root, {viewport, controls, update, destroy() {
      controller.abort();
      observer?.disconnect();
      childrenObserver.disconnect();
      clearTimeout(settleTimer);
      rails.delete(root);
    }});
    update();
  }

  function initCatalogue(root) {
    const form = root.querySelector('[data-arpro-catalogue-filters]');
    if (catalogues.get(root) === form) return;
    const active = root.querySelector('[data-arpro-active-filters]');
    const toggle = root.querySelector('[data-arpro-filter-toggle]');
    const sortSlot = root.querySelector('[data-arpro-sort-slot]');
    if (!form || !active || !toggle || !sortSlot) return;
    catalogues.set(root, form);
    const pairs = [];
    const groups = [];
    ['category', 'brand'].forEach(kind => {
      const source = form.querySelector(`[data-arpro-catalogue-${kind}]`);
      if (!source) return;
      const field = source.closest('.arpro-catalogue__field');
      const title = field && field.querySelector('label');
      if (!field || !title) return;
      const build = () => {
        if (source.options.length < 2 || field.dataset.facetReady) return false;
        const group = document.createElement('fieldset');
        group.className = 'arpro-facet-group';
        const legend = document.createElement('legend');
        legend.textContent = title.textContent;
        group.append(legend);
        const more = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = kind === 'brand' ? arproUi("js_filters_all_brands", "Voir toutes les marques") : arproUi("js_filters_all_categories", "Voir toutes les familles");
        more.append(summary);
        Array.from(source.options).forEach((option, index) => {
          const label = document.createElement('label');
          label.className = 'arpro-facet-option';
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.id = `${source.id}-facet-${index}`;
          radio.name = `${source.id}-facet`;
          radio.value = option.value;
          radio.checked = source.value === option.value;
          radio.disabled = option.disabled;
          radio.dataset.arproFacetControl = kind;
          label.htmlFor = radio.id;
          const text = document.createElement('span');
          text.textContent = option.textContent;
          label.append(radio, text);
          radio.addEventListener('input', () => {
            if (!radio.checked) return;
            source.value = radio.value;
            source.dispatchEvent(new Event('change', {bubbles: true}));
            sync();
          });
          (index < 6 ? group : more).append(label);
          pairs.push({radio, source});
        });
        if (source.options.length > 6) group.append(more);
        field.after(group);
        field.classList.add('arpro-facet-source');
        field.dataset.facetReady = 'true';
        groups.push({more, source});
        return true;
      };
      if (!build()) {
        const observer = new MutationObserver(() => {if (build()) observer.disconnect()});
        observer.observe(source, {childList: true});
      }
    });
    const sourceSort = form.querySelector('[data-arpro-catalogue-sort]');
    let mirrorSort = null;
    if (sourceSort) {
      mirrorSort = sourceSort.cloneNode(true);
      mirrorSort.removeAttribute('data-arpro-catalogue-sort');
      mirrorSort.removeAttribute('name');
      mirrorSort.id = `${sourceSort.id}-toolbar`;
      mirrorSort.dataset.arproSortMirror = '';
      const label = document.createElement('label');
      label.htmlFor = mirrorSort.id;
      label.textContent = arproUi("js_filters_sort_by", "Trier par");
      sortSlot.append(label, mirrorSort);
      sourceSort.closest('.arpro-catalogue__field').classList.add('arpro-facet-source--sort');
      mirrorSort.addEventListener('change', () => {
        sourceSort.value = mirrorSort.value;
        sourceSort.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }
    const filterSources = ['search', 'category', 'brand', 'format', 'abv', 'purchase-status'].map(kind => form.querySelector(`[data-arpro-catalogue-${kind}]`)).filter(Boolean);
    const sync = () => {
      pairs.forEach(({radio, source}) => {radio.checked = radio.value === source.value});
      groups.forEach(({more}) => {if (more.querySelector('input:checked')) more.open = true});
      if (mirrorSort) mirrorSort.value = sourceSort.value;
      active.replaceChildren();
      filterSources.forEach(source => {
        if (!source.value) return;
        const field = source.closest('.arpro-catalogue__field');
        const label = field.querySelector('label').textContent.trim();
        const value = source.tagName === 'SELECT' ? source.options[source.selectedIndex].textContent : source.value;
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = `${label} : ${value} ×`;
        button.setAttribute('aria-label', arproUi("js_filter_remove", "Retirer le filtre {label} : {value}", { label: label, value: value }));
        button.addEventListener('click', () => {
          source.value = '';
          source.dispatchEvent(new Event(source.tagName === 'SELECT' ? 'change' : 'input', {bubbles: true}));
          const result = root.querySelector('[data-arpro-catalogue-result]');
          if (result) {result.setAttribute('tabindex', '-1'); result.focus({preventScroll: true})}
        });
        active.append(button);
      });
      active.hidden = active.children.length === 0;
    };
    form.addEventListener('input', sync);
    form.addEventListener('change', sync);
    form.addEventListener('reset', () => setTimeout(sync, 0));
    const mq = window.matchMedia('(max-width: 63.99rem)');
    const setExpanded = expanded => {
      root.classList.toggle('arpro-catalogue--filters-collapsed', !expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
    };
    toggle.hidden = false;
    setExpanded(!mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', () => setExpanded(!mq.matches));
    toggle.addEventListener('click', () => setExpanded(toggle.getAttribute('aria-expanded') !== 'true'));
    form.addEventListener('keydown', event => {
      if (event.key === 'Escape' && mq.matches) {
        event.preventDefault();
        setExpanded(false);
        toggle.focus();
      }
    });
    sync();
  }

  function initAll(scope = document) {
    if (scope.matches?.('[data-arpro-rail]')) initRail(scope);
    if (scope.matches?.('[data-arpro-catalogue]')) initCatalogue(scope);
    scope.querySelectorAll('[data-arpro-rail]').forEach(initRail);
    scope.querySelectorAll('[data-arpro-catalogue]').forEach(initCatalogue);
    scope.querySelectorAll('[data-arpro-image-zoom]').forEach(button => {
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') button.hidden = false;
    });
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const zoom = event.target.closest('[data-arpro-image-zoom]');
    if (zoom) {
      const dialog = document.getElementById(zoom.getAttribute('aria-controls'));
      const image = dialog && dialog.querySelector('img');
      if (!image || typeof dialog.showModal !== 'function') return;
      image.src = zoom.dataset.arproZoomSrc;
      image.removeAttribute('srcset');
      image.alt = zoom.dataset.arproZoomAlt || '';
      zoomOpeners.set(dialog, zoom);
      dialog.showModal();
      document.body.classList.add('arpro-image-zoom-open');
      return;
    }
    const dialog = event.target.closest('[data-arpro-image-dialog]');
    if (dialog && dialog.open) {
      const rect = dialog.getBoundingClientRect();
      const outside = event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      if (outside || event.target.closest('[data-arpro-image-close]')) dialog.close();
    }
  });
  document.addEventListener('close', event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-arpro-image-dialog]')) return;
    document.body.classList.remove('arpro-image-zoom-open');
    const opener = zoomOpeners.get(event.target);
    if (!document.querySelector('dialog[open]') && opener && opener.isConnected && opener.getClientRects().length) opener.focus();
  }, true);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('arpro:sections-updated', event => initAll(event.detail?.root || document));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-arpro-rail]')) rails.get(event.target)?.destroy();
    event.target.querySelectorAll('[data-arpro-rail]').forEach(root => rails.get(root)?.destroy());
    const dialog = event.target.querySelector('[data-arpro-image-dialog][open]');
    if (dialog) {dialog.close(); document.body.classList.remove('arpro-image-zoom-open')}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), {once:true});
  else initAll();
})();

/* Complete the native filter panel's responsive keyboard behavior. */
(function () {
  'use strict';
  function initializeNativeFilters(root) {
    (root || document).querySelectorAll('[data-arpro-filter-panel]').forEach(function (panel) {
      if (panel.dataset.arproQualityReady === 'true') return;
      panel.dataset.arproQualityReady = 'true';
      var mobile = window.matchMedia('(max-width: 63.99rem)');
      var triggers = Array.from(document.querySelectorAll('[data-arpro-filters-open]')).filter(function (button) {
        return button.getAttribute('aria-controls') === panel.id;
      });
      function sync() {
        var open = mobile.matches && panel.dataset.open === 'true';
        panel.setAttribute('aria-hidden', mobile.matches && !open ? 'true' : 'false');
        triggers.forEach(function (button) { button.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        if (open) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
        }
      }
      function onViewportChange() {
        if (!mobile.matches && panel.dataset.open === 'true') {
          var close = panel.querySelector('[data-arpro-filters-close]');
          if (close) close.click();
        }
        sync();
      }
      var observer = new MutationObserver(sync);
      observer.observe(panel, { attributes: true, attributeFilter: ['data-open'] });
      mobile.addEventListener('change', onViewportChange);
      panel.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !mobile.matches || panel.dataset.open !== 'true') return;
        var controls = Array.from(panel.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,summary,[tabindex="0"]')).filter(function (control) {
          return !control.disabled && control.tabIndex >= 0 && control.getClientRects().length > 0;
        });
        if (!controls.length) return;
        var first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      panel.addEventListener('arpro:quality-destroy', function () { observer.disconnect(); mobile.removeEventListener('change', onViewportChange); }, { once: true });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeNativeFilters(document); });
  else initializeNativeFilters(document);
  document.addEventListener('shopify:section:load', function (event) { initializeNativeFilters(event.target); });
  document.addEventListener('arpro:sections-updated', function (event) { initializeNativeFilters(event.detail && event.detail.root || document); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-arpro-filter-panel]').forEach(function (panel) { panel.dispatchEvent(new Event('arpro:quality-destroy')); });
  });
})();
